let inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

class CatalogService {
    constructor($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
        this.ngAuthSettings = ngAuthSettings;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.$q = $q;
        this.$http = $http;
    }

    getFeaturedProducts(userId, limit) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.featuredProducts + '?userId=' + userId + '&limit=' + limit,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getRelatedProducts(productId, userId, limit) {
        return this.$q((resolve, reject) => {

            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.relatedProducts + productId + '&userId=' + userId + '&limit=' + limit,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getRelatedCategoryProducts(productId, userId, limit,categoryId) {
        return this.$q((resolve, reject) => {

            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.relatedCategoryProducts +
                productId + '&userId=' + userId + '&limit=' + limit + '&categoryId=' + categoryId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getNewProducts(userId, limit) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.newItems + '?userId=' + userId + '&limit=' + limit,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getMostSelledProducts(userId, limit) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.bestSellerItems + '?userId=' + userId + '&limit=' + limit,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    updateFavoriteProducts(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.setFavoriteProduct,
                cache: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }


    getProducts(userId, limit, type,categoryId='',itemId='', categoryIdFilter= '', origin='b2b') {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.
                    boxItems + '?userId=' + userId + '&limit=' + limit + '&type=' + type + '&itemId=' + itemId + '&categoryId=' + categoryId + '&categoryIdFilter=' + categoryIdFilter + '&origin=' + origin,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getFeaturedCategories() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categoryFeatured,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

}

CatalogService.$inject = inject;

export default CatalogService;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/catalog.service.js
 **/